import React, {useCallback, useEffect, useRef, useState} from 'react';
import {SweetAlert} from '../../components/Common/SweetAlert';
import {getLoggedInUser} from '../../helpers/fakebackend_helper';
import {renewUserToken} from '../../api/auth';

const WARN_THRESHOLD = 60; // in s
const POLL_INTERVAL = 6000; // in ms

const SessionTimeout: React.FC = () => {
  const [showAlert, setShowAlert] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const clearTimer = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  const hideAlert = useCallback(() => {
    clearTimer();
    localStorage.removeItem('authUser');
    window.location.href = '/login';
  }, []);

  const startCountdown = useCallback((expiresAt: number) => {
    clearTimer();
    intervalRef.current = setInterval(() => {
      const rem = expiresAt - Math.floor(Date.now() / 1000);
      if (rem <= 0) return hideAlert();
      setSeconds(rem);
      setShowAlert(true);
    }, 1000);
  }, [hideAlert]);

  const checkSession = useCallback(() => {
    const authUser = getLoggedInUser();
    if (!authUser?.expires_at) return;

    const remaining = authUser.expires_at - Math.floor(Date.now() / 1000);

    if (remaining <= 0) return hideAlert();
    if (remaining <= WARN_THRESHOLD) startCountdown(authUser.expires_at);
  }, [hideAlert, startCountdown]);

  const startPolling = useCallback(() => {
    clearTimer();
    intervalRef.current = setInterval(checkSession, POLL_INTERVAL);
    checkSession();
  }, [checkSession]);

  const confirmAlert = useCallback(() => {
    renewUserToken().then((response) => {
      localStorage.setItem('authUser', JSON.stringify(response));
      setShowAlert(false);
      setSeconds(0);
      startPolling();
    });
  }, [startPolling]);

  useEffect(() => {
    startPolling();
    return clearTimer;
  }, [startPolling]);

  return (
    <>
      {showAlert && (
        <SweetAlert
          showCancel
          confirmBtnText="Stay Connected"
          cancelBtnText="Logout"
          confirmBtnBsStyle="yellow"
          cancelBtnBsStyle="danger"
          title="Your Session is About to Expire!"
          text={`Redirecting in ${seconds}s seconds.`}
          onCancel={hideAlert}
          onConfirm={confirmAlert}
        />
      )}
    </>
  );
};

export default SessionTimeout;
